import {useEffect,useState} from 'react';
import {collection,onSnapshot,query,where} from 'firebase/firestore';
import {db} from '../../Security/firebase-config';
import {isAddedOverviewVod} from '../overview/useEventResourcePresence';

export default function useWorkspaceMedia(teamId,slot,eventKey=''){
  const identity=JSON.stringify([teamId,slot.mapId,slot.matchId,eventKey]);
  const [state,setState]=useState(null);
  useEffect(()=>{
    if(!teamId||!slot.mapId||(!slot.matchId&&!eventKey)){setState({identity,rows:[],loading:false});return undefined;}
    let alive=true;const values=new Map(),errors=new Set(),fields=[...(slot.matchId?[['matchId',slot.matchId]]:[]),...(eventKey?[['calendarEventId',eventKey]]:[])];
    const publish=()=>{if(alive)setState({identity,loading:!errors.size&&values.size<fields.length,rows:errors.size?[]:[...new Map([...values.values()].flat().map(row=>[row.id,row])).values()],error:errors.size?'Recordings could not be loaded. Check your connection and team access.':null});};
    const stops=fields.map(([field,value])=>onSnapshot(query(collection(db,'teams',teamId,'maps',slot.mapId,'videos'),where(field,'==',value)),snapshot=>{
      if(!alive)return;errors.delete(field);values.set(field,snapshot.docs.map(doc=>({...doc.data(),id:doc.id})).filter(isAddedOverviewVod));publish();
    },()=>{if(alive){errors.add(field);publish();}}));
    return()=>{alive=false;stops.forEach(stop=>stop());};
  },[identity,teamId,slot.mapId,slot.matchId,eventKey]);
  return state?.identity===identity?state:{rows:[],loading:true};
}
